import { Group, Stack, Text } from '@mantine/core';

import SelectableCard from '@/components/SelectableCard';

import { ProductTypeBadge } from '../components/ProductTypeBadge';
import { MenuStatusBadge } from '../components/MenuStatusBadge';
import { MealPeriodBadges } from '../components/MealPeriodBadges';
import { LastUpdatedText } from '../components/LastUpdatedText';
import { UNTITLED_MENU_TEXT } from '../constants';
import type { MenuTemplateSummary } from '../types';

type MenuTemplateCardProps = {
  template: MenuTemplateSummary;
  isSelected: boolean;
  onSelect: () => void;
};

export const MenuTemplateCard: React.FC<MenuTemplateCardProps> = ({
  template,
  isSelected,
  onSelect,
}) => (
  <SelectableCard isSelected={isSelected} onSelect={onSelect} variant="card" py="sm">
    <Stack gap={8}>
      <Group gap={8} wrap="nowrap" align="center">
        <ProductTypeBadge productType={template.productType} />
        <Text fw={700} size="sm" c="black" truncate="end">
          {template.name || UNTITLED_MENU_TEXT}
        </Text>
      </Group>

      <MealPeriodBadges mealPeriods={template.mealPeriods} />

      <Group gap="sm" wrap="nowrap" align="center">
        <MenuStatusBadge state={template.state} />
        <LastUpdatedText date={template.updatedAt} />
      </Group>
    </Stack>
  </SelectableCard>
);
